import {Card} from 'platform/components';
import {match} from 'ts-pattern';

import {isNil, mergeAll} from 'ramda';

import {GetDirectSaleResponse} from '@dms/api/warehouse';
import {warehouseRoutes} from '@dms/routes';
import {
  DmsDataGrid,
  WAREHOUSE_GRID_CODES,
  catchUnhandledDataGridActions,
  logError,
} from '@dms/shared';

import {composePath, RequiredTestIdProps, suffixTestId, useNavigate} from 'shared/web';

import type {ActionCallback, EagGridMaximization, QueryFilterObject} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['fastTrackIssueNumber'] as const;

interface FastTrackIssuesTabProps extends RequiredTestIdProps {
  maximization?: EagGridMaximization;
  directSale: GetDirectSaleResponse;
}

export function FastTrackIssuesTab(props: FastTrackIssuesTabProps) {
  const navigate = useNavigate();

  const queryModifier = (filter: QueryFilterObject) =>
    mergeAll([filter, {originEntityId: props.directSale.id}]);

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    getColumnData,
  }) => {
    const fastTrackIssueId = getColumnData<{id: string}>('fastTrackIssueNumber')?.value?.id;

    if (isNil(fastTrackIssueId)) {
      return logError('Fast track item id is not defined');
    }

    match(actionKey)
      .with('redirectDetail', () => {
        navigate(
          composePath(warehouseRoutes.fastTrackIssuesDetailOverview, {
            params: {
              id: fastTrackIssueId,
            },
            isSearchParamsPreserved: false,
          })
        );
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <Card isFullHeight>
      <DmsDataGrid
        maximization={props.maximization}
        gridCode={WAREHOUSE_GRID_CODES.fastTrackIssueItemsRelatedSourceDoc}
        queryModifier={queryModifier}
        actionCallback={actionCallback}
        predefinedColumns={PREDEFINED_COLUMNS}
        data-testid={suffixTestId(WAREHOUSE_GRID_CODES.fastTrackIssueItemsRelatedSourceDoc, props)}
      />
    </Card>
  );
}
